import React, { useState, useEffect } from "react";
import { FormSelect } from "shards-react";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import { useTranslation } from "react-i18next";

const SelectagencyType = (props) => {
  const { token } = useToken();
  const { i18n } = useTranslation();
  const { placeholder, name, onChange, value, invalid, onBlur } = props;
  const [agencyTypeList, setAgencyList] = useState(null);

  useEffect(() => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      show: 10,
      page: 1,
      orderBy: "agencyTypeId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/agencytypelist`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setAgencyList(response.data.data);
      })
      .catch(function(error) {
        console.log("setting/agencytypelist", error);
      });
  }, []);

  return (
    <FormSelect
      placeholder={placeholder}
      name={name}
      onChange={onChange}
      value={value}
      invalid={invalid}
      onBlur={onBlur}
    >
      <option value="0">-{placeholder}-</option>
      {agencyTypeList != null &&
        agencyTypeList.map((item, key) => (
          <option
            key={key}
            value={item.agencyTypeId}
            title={
              i18n.language === "th"
                ? item.agencyTypeName
                : item.agencyTypeNameEN || item.agencyTypeName
            }
          >
            {i18n.language === "th"
              ? item.agencyTypeName
              : item.agencyTypeNameEN || item.agencyTypeName}
          </option>
        ))}
    </FormSelect>
  );
};
export default SelectagencyType;
